import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { LayoutRevisionState } from './types';

export const getters: GetterTree<LayoutRevisionState, RootState> = {
};
